import {fetchWrapper} from "../../helpers/fetch.wrapper";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const userProfileService = {
    customerInfo,
    updateEmail,
    updatePassword,
    updateProfile,
    saveAddress,
    updateAddress,
    getCustomerAddress,
    deleteAddress,
    getLoyaltyNumber,
    updateStore,
    deleteProfile,
    syncAddress,
    getMFAMethods,
    deleteMFAMethod,
    resetPasswordTicket,
    updatePhone
}


async function saveAddress(addressDetails) {
    return fetchWrapper.post(`${baseUrl}/customer/address`, addressDetails)
        .then(response => {
            return response;
        });
}

async function customerInfo() {

    return fetchWrapper.get(`${baseUrl}/customer`)
        .then(response => {
            return response;
        });
}

async function getCustomerAddress() {

    return fetchWrapper.get(`${baseUrl}/customer/address`)
        .then(response => {
            return response;
        });
}

async function syncAddress() {

    return fetchWrapper.get(`${baseUrl}/customer/sync-address`)
        .then(response => {
            return response;
        });
}

async function updateEmail() {

    return fetchWrapper.put(`${baseUrl}/customer/email`, {})
        .then(response => {
            return response;
        });
}

async function updatePhone() {

    return fetchWrapper.put(`${baseUrl}/customer/phone`, {})
        .then(response => {
            return response;
        });
}

async function updateAddress(addressDetails, id) {

    return fetchWrapper.put(`${baseUrl}/customer/address/${id}`, addressDetails)
        .then(response => {
            return response;
        });
}

async function updatePassword(passwordDetails) {

    return fetchWrapper.put(`${baseUrl}/customer/password`, passwordDetails)
        .then(response => {
            return response;
        });

}

async function updateProfile(profileDetails, email) {

    return fetchWrapper.put(`${baseUrl}/customer/profile/${email}`, profileDetails)
        .then(response => {
            return response;
        });

}

async function deleteProfile(scope) {
    return fetchWrapper.post(`${baseUrl}/customer/delete/profile`, {}, scope)
        .then(response => {
            return response;
        });

}

async function updateStore(storeInfo, email) {

    return fetchWrapper.put(`${baseUrl}/customer/update-store/${email}`, storeInfo)
        .then(response => {
            return response;
        });

}

async function deleteAddress(id) {

    return fetchWrapper.delete(`${baseUrl}/customer/address/${id}`)
        .then(response => {
            return response;
        });

}

async function getMFAMethods() {
    return fetchWrapper.get(`${baseUrl}/auth0/mfa/authenticated/methods`)
        .then(response => {
            return response;
        });
}


async function deleteMFAMethod(methodType, methodId, scope) {
    return fetchWrapper.delete(`${baseUrl}/auth0/mfa/authenticated/methods/delete/${methodType}/${methodId}`, scope
    )
        .then(response => {
            return response;
        });
}

async function resetPasswordTicket(scope) {
    return fetchWrapper.post(`${baseUrl}/customer/change/password/ticket`, {}, scope)
        .then(response => {
            return response;
        });

}

async function getLoyaltyNumber(phoneNumber, customerId) {

    return fetchWrapper.get(`${baseUrl}/inteq/loyalty/${phoneNumber}/${customerId}`)
        .then(response => {
            return response;
        });
}
